import React, { useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import SimilarPosts from "../../SearchAll/AllPosts/SimilarPosts";
import Access from "../../../../CustomComponents/Access/Access";
import getTimeDifference from "../../../../Common/TimeDifference";
import {
  formatNumberWithCommas,
  getMemberSince,
  getPosttype,
} from "../../../../Common/AllDateTimeReleventFormate";
import { addtowishinpostbyid } from "../../../../../redux/posts/action";
import { useDispatch } from "react-redux";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import { getSortNamePostType, IS_LOGGED_IN_USER, decodeHtml } from "../../../../../assests/extention/commonfunction";
import AbouttheClient from "../../../../Common/AbouttheClient";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";
import AbouttheClientforContest from "../../../../Common/AbouttheClientforContest";
import img from '../../../../../assests/imgs/contest.png'
import ParticipateImage from "./ParticipateImage";

export default function ContestDescription({ posts }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);

  const applyandbitjob = () => {
    setModal(true);
  };
  const dispatch = useDispatch();
  const addtowishlist11 = (id) => {
    dispatch(addtowishinpostbyid(id));
  };

  return (
    <div className="row">
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${lan}/submitcontest/${posts.id}`}
          state={"state"}
          checkpermission={"participate_contest"}
          masterID={posts && posts.id}
        />
      ) : (
        ""
      )}
      <div className="col-lg-9 col-md-8">
        <div className="post-details p-0" style={{ border: "0" }}>
          <div className="filter-detail justify-contnt-between">
            <div className="w-100">
              <h5>
                {decodeHtml(posts.title)} {getSortNamePostType(posts.type)}
              </h5>
              <div className="dollar-sec">
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/Prize.svg`}
                    alt=""
                  />
                  {posts?.type == 2 ? "Prize" : "Budget"}: $
                  {formatNumberWithCommas(posts.price)}
                </p>
                {posts?.type == 3 ? (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                      alt=""
                    />
                    Job type:
                    {posts?.work_location == 1
                      ? "Virtual"
                      : posts?.work_location == 2
                        ? "Physical"
                        : ""}
                  </p>
                ) : (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                      alt=""
                    />
                    Deadline:&nbsp;
                    {posts?.type == 2 ? (
                      <> {getMemberSince(posts?.last_date)} </>
                    ) : (
                      <>
                        {posts?.duration}&nbsp;
                        {posts?.duration_type == 1
                          ? "Days"
                          : posts?.duration_type == 2
                            ? "Weeks"
                            : posts?.duration_type == 3
                              ? "Months"
                              : ""}
                      </>
                    )}
                  </p>
                )}

                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                    alt=""
                  />
                  Posted:{getTimeDifference(posts.created_on)}
                </p>
              </div>
              <CustomeCategoryandSubcategory posts={posts} />
              <div className="lang-sec">
                <h6>Preferred language</h6>
                <p>{decodeHtml(posts.language_title)}</p>
              </div>
              <div className="lang-sec">
                <h6>Description</h6>
                <CustomReactQuillDescription value={posts.description} />
              </div>
              <div className="lang-sec">
                <h6>Competencies and expertise</h6>
                <div className="skills-expert">
                  {posts.skills &&
                    Array.isArray(posts.skills) &&
                    posts.skills.map((item, index) => {
                      return <p key={index}> {decodeHtml(item.title)} </p>;
                    })}
                </div>
              </div>
              {Array.isArray(posts?.files) &&
                posts?.files &&
                posts?.files?.length > 0 && (
                  <div className="lang-sec">
                    <h6>Attachments</h6>
                    <div className="images">
                      {posts?.files &&
                        Array.isArray(posts?.files) &&
                        posts?.files.map((item, index) => {
                          return <DownloadwithDisplayProper item={item} />;
                        })}
                    </div>
                  </div>
                )}

              <div className="lang-sec">
                <h6>Deliverables</h6>
                <CustomReactQuillDescription value={posts?.deliverables} />
              </div>
              <div className="lang-sec">
                <h6 className="activity-post"> Activity on this post</h6>
                <div className="post-p">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                      alt=""
                    />
                    Entries: {posts?.proposal_count}
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/eye.svg`}
                      alt=""
                    />
                    Last viewed by client:
                    {getTimeDifference(posts?.last_viewed_client)}
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/interview.svg`}
                      alt=""
                    />
                    Seen: {posts?.view_count}
                  </p>
                </div>
              </div>
            </div>
            <button
              className="btn heart-btn"
              onClick={() => {
                if (localStorage.getItem("urexperttoken")) {
                  posts.wishlist == 1
                    ? addtowishlist11(posts?.id, 1)
                    : addtowishlist11(posts?.id, 1);
                }
                else {
                  setModal(true);
                }
              }}
            >
              {posts.wishlist == 1 ? (
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                  alt=""
                />
              ) : (
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                  alt=""
                />
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-4">
        <div className="like-project">
          <div className="first-sec mb-0" style={{ border: '0' }}>
            <ParticipateImage />
            <h5> {posts.is_mine == 1 ? "Your post" : "Participate"}</h5>
            <p>
              {posts.is_mine == 1 ? (
                <>
                  {posts.proposal_count > 0 ? (
                    <>
                      <button
                        className="btn"
                        onClick={() =>
                          navigate(
                            `/${lan}/dashboard/myorders/contest/active/${posts.id}`
                          )
                        }
                      >
                        Contest Details
                      </button>
                    </>
                  ) : (
                    "Do you want to modify this post"
                  )}
                </>
              ) : (
                "Upload file to participate"
              )}
            </p>
            {posts.is_mine == 1 && posts.proposal_count == 0 && (
              <button
                className="btn"
                onClick={() =>
                  navigate(`/${lan}/account/updatecontest/${posts.id}`)
                }
              >
                Update
              </button>
            )}
            {posts.is_mine == 1 ? (
              ""
            ) : (
              <>
                {Array.isArray(posts?.my_proposal) &&
                  posts?.my_proposal?.length > 0 ? (
                  <button
                    className="btn"
                    disabled
                    style={{ color: "green", background: "lightgreen" }}
                  >
                    Submitted
                  </button>
                ) : (
                  <button
                    className="btn"
                    disabled={posts.is_mine == 1}
                    onClick={() => {
                      applyandbitjob();
                    }}
                  >
                    Submit entry
                  </button>
                )}
              </>
            )}
            {posts.is_mine == 1 && posts.status == 10 && (
              <button
                className="btn"
                onClick={() =>
                  navigate(`/${lan}/account/updatecontest/${posts.id}`)
                }
              >
                Update
              </button>
            )}
          </div>

        </div>
        <div className="like-project mt-3">
          {posts.is_mine == 1 ? (
            ""
          ) : (
            <AbouttheClientforContest posts={posts} />
          )}
        </div>
      </div>
      <div className="col-lg-9 col-md-8">
        <SimilarPosts posts={posts} />
      </div>
    </div>
  );
}
